import React from "react";
import { GarantiasVehicularInmobiliariaResponse } from "@interfaces/response";
import { Typography } from "@mui/material";

interface GuaranteeTitleProps {
  guarantee_item: GarantiasVehicularInmobiliariaResponse;
  guarantee_index: number;
}

const getGuaranteeTitle = (guarantee_item: GarantiasVehicularInmobiliariaResponse, guarantee_index: number) => {
  if (guarantee_item.details) {
    const { make, model, year, version } = guarantee_item.details;
    if (make && model && year && version) {
      return `${make} | ${model} | ${year} | ${version}`;
    }
  }

  if (guarantee_item.guarantee_type?.name) {
    return guarantee_item.guarantee_type.name;
  }

  return `Garantía ${guarantee_index + 1}`;
};

const GuaranteeTitle = (props: GuaranteeTitleProps) => {
  const { address } = props.guarantee_item;
  const title = getGuaranteeTitle(props.guarantee_item, props.guarantee_index);

  return (
    <React.Fragment>
      <Typography variant="h6" fontWeight={600} color="primary.dark">
        {title}
      </Typography>
      {address && (
        <Typography variant="body1" fontWeight={400} color="text.secondary">
          {address}
        </Typography>
      )}
    </React.Fragment>
  );
};

export default GuaranteeTitle;
